const opinionTool = document.getElementById("opinion-tool");

if (opinionTool) {
    window.addEventListener('scroll', function(e) {
        const contentHeight = document.getElementById("body").offsetHeight - window.innerHeight;

        const scrolled = window.pageYOffset + document.getElementById("footer").offsetHeight;

        if (scrolled > contentHeight) {
            if ( !opinionTool.classList.contains('opinion-absolute') ) {
                opinionTool.classList.add('opinion-absolute')
            }
        } else {
            if ( opinionTool.classList.contains('opinion-absolute') ) {
                opinionTool.classList.remove('opinion-absolute')
            }
        }
    });
}


const closeOpinionTool = document.getElementById('close-opinion-tool');
if (closeOpinionTool) {
    closeOpinionTool.addEventListener('click', function (event){
        event.preventDefault();
        opinionTool.remove();
    })
}

const showInfoBetaAction = document.getElementById('show-info-beta');

if (showInfoBetaAction) {
    showInfoBetaAction.addEventListener('click', function(e) {
        const bodyElement = document.getElementById('body');
        if (bodyElement.classList.contains('info-beta-show')) {
            bodyElement.classList.remove('info-beta-show');
        } else {
            bodyElement.classList.add('info-beta-show');
        }
    });
}


const linkRegistro = document.getElementById('link-registro');
if (linkRegistro) {
    linkRegistro.addEventListener('click', function (event){
        event.preventDefault();

        var data = new FormData();
        var token = document.head.querySelector('meta[name="csrf-token"]');
        var usuario_id = linkRegistro.getAttribute("data-user");
        var src = linkRegistro.getAttribute("data-ruta");
        var url_base = linkRegistro.getAttribute("data-baseurl");

        data.append('_token', token.content);
        data.append('user_core_id', usuario_id);

        fetch(url_base + '/obtener-token-acceso-personal', {
            method: 'POST',
            body: data,
            redirect: "follow"
        }).then((response) => response.json())
        .then(function (data) {
            if(data.mensaje == 'success'){
                const linkToken = document.getElementById('link-token');
                linkToken.setAttribute("href", src+'/acceso-personal-token/'+usuario_id+'/'+data.token);
                linkToken.click()
            }
        });
    })
}
